import axios from 'axios';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom'
import { GROLOG_URL } from '../../../../constant/apiConstant';
import {
  getDetail,
  getManagementHistoryList
} from '../../../../service/setup/TemperatureCategory/TemperatureCategoryService';
import { validTemperature } from '../validation-temperature';
import { t } from 'i18next';
import { validateSubmit } from '../../../../util';
import { onChanged } from '../../../../util/Util';
import { ROUTES } from '../../../../constant/routeConstant';
import moment from "moment/moment";

function useEditTemperature() {
  const { token } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [desc, setDesc] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState([]);
  const [err, setErr] = useState("");
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messageFailed, setMessageFailed] = useState('');
  const [showConfirm, setShowConfirm] = useState(false)
  const [isChanged, setIsChanged] = useState(false)

  const [userManagementOpen, setUserManagementOpen] = useState(false)
  const [managementHistoryList, setManagementHistoryList] = useState([])


  const getDetailDataGroup = async () => {
    try {
      const response = await getDetail(token, null, location?.state?.id, dispatch);
      if (response && response.ok) {
        setData(response?.data);
        initiateData(response?.data);
        setLoading(false);
      }
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    getDetailDataGroup()
    doGetManagementHistoryList(location?.state?.id)
    // eslint-disable-next-line
  }, []);

  const initiateData = (data) => {
    setName(data?.name)
    setCode(data?.code)
    setDesc(data?.description)
  }

  const handleBack = () => {
    const prevPage = location?.state?.prevPage;

    if (!isChanged) {
      if (prevPage.includes('detail')) {
        navigate(prevPage, { state: { id: location?.state?.id, prevPage } })
      } else {
        navigate(prevPage);
      }
    } else{
      setShowConfirm(true)
    }
  }

  const _onChange = (evt, namespace) => {
    setErr("")

    onChanged(dispatch, true)
    setIsChanged(true)

    switch (namespace) {
      case 'name':
        let erorName = validTemperature(namespace, evt.target.value, t);
        setError({ ...error, ...erorName });
        setName(evt.target.value)
        break;
      case 'desc':
        let erorDesc = validTemperature('description', evt.target.value, t);
        setError({ ...error, ...erorDesc });
        setDesc(evt.target.value)
        break;
      case 'code':
        let erorCode = validTemperature(namespace, evt, t);
        setError({ ...error, ...erorCode });
        setCode(evt)
        break;
      default:
        break;
    }
  }

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {

    const api = GROLOG_URL;
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  }

  const getDropdown = async (data, sort) => {
    setLoading(true)
    let res = await doGet(
      `/uom?page=${page}&limit=${limit}&filter=category eq T`, token
    );

    const list = res?.data?.payload?.data;
    if (list && list.length > 0) {
      mapingList(list)
    }
    setLoading(false)
  }

  const mapingList = async (data) => {
    const newDatas = data.map((item) => {
      return { label: item?.uom_category_code, value: item?.uom_id }
    });

    setList(newDatas)
  }

  useEffect(() => {
    getDropdown();
    // eslint-disable-next-line
  }, [page, limit]);


  const _onSave = () => {
    let errors = {};
    const datas = {
      code,
      name,
      description: desc,
      updated_at: data?.updated_at
    }

    const keys = {
      code,
      name,
      description: desc
    }

    for (const key in keys) {
      const option = validTemperature(key, keys[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      const api = GROLOG_URL;
      const headers = { "Authorization": token };

      axios.put(`${api}/temperature-category/${location?.state?.id}`, datas, { headers })
        .then(response => {
          if (response?.status === 200) {
            setVisible(true)
          }
        }).catch((error) => {
          const errorCode = error?.response?.status;

          if (errorCode === 400) {
            const errorMessage = error?.response?.data?.payload?.message;
            setMessageFailed(errorMessage);
            setFailedModalOpen(true);
          }
        });
    } else {
      setError(errors);
    }
  }

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  }

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return (moment(timestamp).utc().format('HH:mm'))
  }

  const doGetManagementHistoryList = async (id) => {
    try {
      const response = await getManagementHistoryList(token, null, dispatch, id);
      if (response && response.ok) {
        const data = response.data
        const reorderedData = []

        for (let i = data.length - 1; i >= 0; i--) {
          const element = data[i];
          reorderedData.push(element)
        }

        setManagementHistoryList(reorderedData)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleOk = () => {
    setVisible(false);
    navigate(ROUTES.TEMPERATURE_CATEGORY.LIST)
    // handleBack();
  }

  return {
    handleBack,
    data,
    loading,
    code,
    name,
    desc,
    _onChange,
    list,
    setList,
    _onSave,
    visible,
    handleOk,
    error,
    err,
    setPage,
    setLimit,
    messageFailed,
    setFailedModalOpen,
    failedModalOpen,
    showConfirm,
    setShowConfirm,
    convertTimestamp,
    convertToTime,
    userManagementOpen,
    setUserManagementOpen,
    managementHistoryList
  }
}

export default useEditTemperature;